import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Icon, Card, Grid, Dropdown, Button, Label} from 'semantic-ui-react';
import moment from 'moment';
import {Actions} from '../../common/actions';
import {paths} from '../../common/dictionaries/urls';
import {hasAccessPermission} from '../../common/permissions/validations';
import {resources, scopes} from '../../common/permissions/dictionary';
import {getNumericValue} from '../../common/util/fieldsValidation';
import {downloadFile} from '../../common/util/file';
import {warehouseOptions} from '../../common/constants/lists';
import {yearsOptions} from '../../common/constants/years';
import {monthsOptions} from '../../common/constants/months';
import TableRecords from './tableRecords';
import './closemonth.scss';

class MonthClose extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'year': moment().year(),
      'month': moment().month(),
      'area': 'TODOS',
    };
    this.search = this.search.bind(this);
    this.execute = this.execute.bind(this);
    this.download = this.download.bind(this);
    this.searchDif = this.searchDif.bind(this);
  }

  componentDidMount() {
    this.props.deleteMonthCloseReport();
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.MonthClose,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.search();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.urlFile !== this.props.urlFile && this.props.urlFile) {
      downloadFile(this.props.urlFile);
      this.props.deleteUrl();
    }
  }

  renderSearchButton() {
    const {loading} = this.props;
    return (
      <Button
        primary
        className='toyota-primary'
        disabled={loading}
        onClick={this.search}
        size='medium'
      >
        Consultar
      </Button>
    );
  }

  renderExecuteButton() {
    const {loading, loadButton} = this.props;
    return (
      <Button
        primary
        className='toyota-primary'
        disabled={loading}
        loading={loadButton}
        onClick={this.execute}
        size='medium'
      >
        Ejecutar
      </Button>
    );
  }

  renderDownloadButton() {
    const {loading} = this.props;
    return (
      <Button
        primary
        className='toyota-primary'
        disabled={loading}
        onClick={this.download}
      >
        <Icon fitted name='download' size='large' />
        Descargar
      </Button>
    );
  }

  search() {
    const {year, month, area} = this.state;
    this.props.fetchMonthCloseReport({month, year, area, 'difference': 'false'});
  }

  searchDif() {
    const {year, month, area} = this.state;
    this.props.fetchMonthCloseReport({month, year, area, 'difference': 'true'});
  }

  execute() {
    const {year, month} = this.state;
    this.props.executeMonthClose(month, year);
  }

  download() {
    const {year, month, area} = this.state;
    this.props.downloadMonthCloseReportFile(month, year, area);
  }

  render() {
    const {year, month, area} = this.state;
    const {temsCost, jdeCost, temsItems, jdeItems, difference} = this.props;
    return (
      <div className='set-sales-list'>
        <Card raised fluid>
          <div className='filters-section'>
            <Grid padded>
              <Grid.Row>
                <Grid.Column width={3}>
                  <h1>Cierre de mes</h1>
                </Grid.Column>
                <Grid.Column width={7}>
                  <div className='change-height-of-dropdown'>
                    <Dropdown
                      selection
                      search
                      value={month}
                      onChange={(e, {value}) =>
                        this.setState({'month': value})
                      }
                      name='list-invoices-container'
                      options={monthsOptions}
                      placeholder='Seleccionar mes'
                    />
                    <Dropdown
                      selection
                      search
                      value={year}
                      onChange={(e, {value}) =>
                        this.setState({'year': value})
                      }
                      label='Seleccionar año'
                      options={yearsOptions}
                      placeholder='Seleccionar año'
                    />
                    <Dropdown
                      selection
                      search
                      value={area}
                      onChange={(e, {value}) =>
                        this.setState({'area': value})
                      }
                      label='Seleccionar area'
                      options={warehouseOptions}
                      placeholder='Seleccionar area'
                    />
                  </div>
                </Grid.Column>
                <Grid.Column width={6}>
                  <div className='title-bar-actions'>
                    {this.renderSearchButton()}
                    {this.renderExecuteButton()}
                    {this.renderDownloadButton()}
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
        </Card>

        <Card fluid raised>
          <Grid columns={5} padded>
            <Grid.Row>
              <Grid.Column>
                <Label color='blue' size='large'>
                  Total Existencia Tems {getNumericValue(temsItems)}
                </Label>
              </Grid.Column>
              <Grid.Column>
                <Label color='teal' size='large'>
                  Total Existencia Jde {getNumericValue(jdeItems)}
                </Label>
              </Grid.Column>
              <Grid.Column>
                <Label color='blue' size='large'>
                  Total Costo Tems ${getNumericValue(temsCost, 2)}
                </Label>
              </Grid.Column>
              <Grid.Column>
                <Label color='teal' size='large'>
                  Total Costo Jde ${getNumericValue(jdeCost, 2)}
                </Label>
              </Grid.Column>
              <Grid.Column>
                <Label
                  color='red'
                  size='large'
                  onClick={this.searchDif.bind(this)}
                  as='a'
                >
                  Diferencias Costo ${getNumericValue(difference, 2)}
                </Label>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <TableRecords />
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const temsCost = state.monthClose.list.reduce((acc, list) => acc + list.totalTemsCost, 0);
  const jdeCost = state.monthClose.list.reduce((acc, list) => acc + list.totalJdeCost, 0);
  const temsItems = state.monthClose.list.reduce((acc, list) => acc + list.temsStock, 0);
  const jdeItems = state.monthClose.list.reduce((acc, list) => acc + list.jdeStock, 0);
  const difference = state.monthClose.list.reduce((acc, list) => acc + list.difference, 0);
  return {
    'permissions': state.session.permissions,
    'loading': state.monthClose.loading,
    'list': state.monthClose.list,
    'urlFile': state.monthClose.urlFile,
    'loadButton': state.monthClose.loadButton,
    'temsCost': temsCost,
    'jdeCost': jdeCost,
    'temsItems': temsItems,
    'jdeItems': jdeItems,
    'difference': difference,
  };
};

const {
  executeMonthClose,
  fetchMonthCloseReport,
  deleteMonthCloseReport,
  downloadMonthCloseReportFile,
  deleteUrl,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  executeMonthClose,
  fetchMonthCloseReport,
  deleteMonthCloseReport,
  downloadMonthCloseReportFile,
  deleteUrl,
  navigateTo,
})(MonthClose);
